export default __webpack_public_path__ + "static/media/riteofblood.9df40d42.png";